import { render, staticRenderFns } from "./TabAlimentacaoRefeicao.vue?vue&type=template&id=58b4900f&scoped=true"
import script from "./TabAlimentacaoRefeicao.vue?vue&type=script&lang=js"
export * from "./TabAlimentacaoRefeicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4900f",
  null
  
)

export default component.exports